import { useQuery } from "@apollo/client";
import { useLocation } from "react-router-dom"
import { GET_SALES_RETURNS, SALE_DETAIL } from "../../apollo/queries";

const useSalesReturn = () => {

    const { state } = useLocation()

    const { data, loading, refetch } = useQuery(SALE_DETAIL, {
        variables: {
            getSaleId: state?.id ?? null,
        },
        skip: !state?.id,
        fetchPolicy: "network-only",
    });

    const { data: sales_return_data, loading: sales_return_loading } = useQuery(GET_SALES_RETURNS, {
        variables: {
            input: {
                sales_id: state?.id ?? null,
                pageStart: 0,
                limit: 10
            }
        },
        skip: !state?.id,
        fetchPolicy: "network-only",
    });

    console.log("sales", sales_return_data);


    return {
        values: {
            data: data?.getSale ?? null,
            sales_return_data: sales_return_data?.allSaleReturns ?? null,
            loading: loading || sales_return_loading
        },
        functions: {
            refetch
        }
    }

}

export default useSalesReturn